export default {
      id: "advancedFilter-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#advancedFilter-usage",
      toString: function () {
        return this.url;
      }
    }